import React from 'react';
import { Mail, Send, Inbox, Link, Settings } from 'lucide-react';
import { useLanguage } from '../i18n';

const tabs = [
  { id: 'dashboard', icon: Inbox, labelKey: 'nav_dashboard' },
  { id: 'emails', icon: Mail, labelKey: 'nav_emails' },
  { id: 'mappings', icon: Link, labelKey: 'nav_mappings' },
  { id: 'send', icon: Send, labelKey: 'nav_send' },
  { id: 'admin', icon: Settings, labelKey: 'nav_admin' },
];

const BottomNav = ({ activeTab, onTabChange }) => {
  const { t } = useLanguage();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pt-2"
         style={{ background: 'linear-gradient(to top, #0a0e1a 60%, transparent)' }}>
      <div className="glass-nav nav-shimmer rounded-2xl p-2 flex justify-around items-center max-w-md mx-auto">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              id={'nav-' + tab.id}
              onClick={() => onTabChange(tab.id)}
              className={
                'relative flex flex-col items-center gap-0.5 px-2 py-2 rounded-xl transition-all duration-300 flex-1 ' +
                (isActive ? 'text-blue-400' : 'text-white/40 hover:text-white/70')
              }
            >
              {isActive && (
                <div className="absolute inset-0 bg-blue-500/10 rounded-xl border border-blue-500/20" />
              )}
              <Icon size={18} className="relative z-10" strokeWidth={isActive ? 2.5 : 1.5} />
              <span className={'text-[9px] relative z-10 font-medium leading-tight ' + (isActive ? 'opacity-100' : 'opacity-60')}>
                {t(tab.labelKey)}
              </span>
              {isActive && (
                <div className="absolute -bottom-0.5 w-1 h-1 bg-blue-400 rounded-full shadow-lg shadow-blue-400/50" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
